import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './MiniProductsCarouselHome.css';
import { useNavigate } from 'react-router-dom';
import { FaShoppingCart } from "react-icons/fa";

const MiniProductsCarouselHome = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get('/api/products');
        setProducts(res.data.slice(0, 8));
      } catch (err) {
        console.error('שגיאה בטעינת מוצרים:', err);
      }
    };
    fetchProducts();
  }, []);

  const handleCardClick = (product) => {
    if (window.gtag) {
      window.gtag('event', 'GalleryCardsProducts', {
        event_category: 'HomepageCarousel',
        event_label: `Product ID ${product.id} - ${product.name}`,
      });
    }
    navigate(`/product/${product.id}`);
  };

  const handleButtonClick = () => {
    if (window.gtag) {
      window.gtag('event', 'GalleryButtonProducts', {
        event_category: 'HomepageCarousel',
        event_label: 'Clicked Products Button',
      });
    }
    navigate('/products');
  };

  const handleAddToCart = (product) => {
    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    const alreadyInCart = cart.find(item => item.id === product.id);

    if (!alreadyInCart) {
      cart.push({
        id: product.id,
        name: product.name,
        price: product.price,
        image: JSON.parse(product.images)[0]
      });
      localStorage.setItem('cart', JSON.stringify(cart));
    }

    if (window.gtag) {
      window.gtag('event', 'AddToCartProductHomepageCarousel', {
        event_category: 'HomepageCarousel',
        event_label: product.name,
        value: product.price
      });
    }

    alert('המוצר נוסף לסל ✔');
  };

  const handleBuyNow = (product) => {
    handleAddToCart(product);
    if (window.gtag) {
      window.gtag('event', 'BuyNowProductHomepageCarousel', {
        event_category: 'HomepageCarousel',
        event_label: product.name,
        value: product.price
      });
    }
    navigate('/cashout');
  };

  return (
    <div className="mini-carousel-wrapper">
      <h2 className="mini-carousel-title">מוצרים שיכולים לעניין אותך</h2>

      <p className="mini-carousel-subtext">
        בוא תגלה את החנות המיוחדת שלנו לנהגי מוניות – מוצרים נבחרים לשדרוג הנסיעה, שיפור הנראות והנוחות ביומיום.
        כל פריט נבחר בקפידה כדי לעזור לך להיראות מקצועי, להרגיש טוב, ולהרוויח יותר.
      </p>

      <div className="mini-carousel-container">
        {products.map((product) => (
          <div key={product.id} className="mini-card">
            <div className="mini-card-image-wrapper" onClick={() => handleCardClick(product)}>
              <span className="sale-badge">🔥 Sale</span>
              <img
                src={JSON.parse(product.images)[0]}
                alt={product.name}
                className="mini-card-image"
              />
            </div>
            <div className="mini-card-info">
              <h4 className="mini-card-title">{product.name}</h4>
              <p className="mini-card-price">{product.price} ₪</p>
                            <div className="mini-card-buttons">
                <button className="mini-buy-now-btn" onClick={() => handleBuyNow(product)}>
                  קנה עכשיו
                </button>
                <button className="mini-add-to-cart-btn" onClick={() => handleAddToCart(product)}>
                  הוסף לסל <FaShoppingCart />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mini-carousel-footer">
        <button className="mini-carousel-button attention" onClick={handleButtonClick}>
          החנות לקיץ
        </button>
      </div>
    </div>
  );
};

export default MiniProductsCarouselHome;
